module.exports = __webpack_public_path__ + "img/8_kim_d.a7c08aa2.png";